<template>
  <el-dialog
    :visible.sync="visible"
    width="420px"
    :before-close="() => (visible = false)"
    :style="{ opacity: showWechat ? 0 : 1 }"
  >
    <div slot="title">
      <span :style="{ fontWeight: 'bold' }">请选择审查立场</span>
      <span :style="{ color: '#9599A5', fontSize: '14px', marginLeft: '8px' }">审查并使用1次AI审查次数</span>
    </div>
    <div class="pick-position-modal" v-loading="modalLoading">
      <div class="pick-position-help-tip">
        <span>更多细化的合同分类即将上线，若有个性化的合同类别审查需求请</span>
        <el-button type="text" :style="{ padding: 0 }" @click="showWechat = true">
          <span>联系我们</span>
        </el-button>
        <span>。</span>
      </div>
      <el-form @submit.native.prevent label-width="110px">
        <el-form-item label="审查合同类型" v-if="!isEmptyFile">
          <el-select
            v-model="classId"
            :disabled="!!curCheckRole"
            placeholder="可输入关键词检索更多合同类型"
            filterable
            remote
            :remote-method="keyword => fetchClassList({ keyword, type })"
            :loading="classLoading"
            reserve-keyword
            popper-class="pick-position-select"
            @change="id => initCheckDetail(id)"
            :style="{ width: '190px' }"
          >
            <el-option
              v-for="classItem in classList"
              :key="classItem._id"
              :value="classItem._id"
              :label="classItem._source.realName"
              :disabled="classItem._id === 'disabled-item'"
            >
              <span v-html="formatClassName(classItem._source.realName, curSearchKeyword)"></span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审查立场">
          <div class="position-tip" v-if="errMsg">
            {{ classId || isEmptyFile ? errMsg : '请先选择【审查合同类型】' }}
          </div>
          <el-radio-group v-model="role" v-else>
            <el-radio v-for="(roleItem, roleIndex) in roleOptions" :key="roleIndex" :label="roleItem">
              <div class="position-radio-text single-ellipsis">{{ roleItem }}</div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" v-if="!modalLoading">
      <el-button @click="visible = false">取 消</el-button>
      <el-button
        :disabled="!!(modalLoading || !classId || errMsg)"
        type="primary"
        :loading="confirmLoading"
        @click="confirmHandle"
        >确 定</el-button
      >
    </span>

    <categoryTipModal
      v-if="categoryTipModal.show"
      :show.sync="categoryTipModal.show"
      :productInfo="categoryTipModal.productInfo"
      @buySuccess="confirmHandle()"
    />

    <customService :show.sync="showWechat" />
  </el-dialog>
</template>

<script>
import { services } from '@/service';
import { usedLimitErrCode, categoryLimitErrCode } from '@/constant';
import categoryTipModal from './categoryTipModal';
import customService from '@/components/customService';

export default {
  components: { categoryTipModal, customService },
  data() {
    return {
      modalLoading: false,
      role: '',
      roleOptions: [],
      classId: '',
      type: '',
      classList: [],
      classLoading: false,
      curSearchKeyword: '',
      confirmLoading: false,
      errMsg: '',
      curCheckRole: '',
      categoryTipModal: {
        show: false,
        productInfo: null
      },
      showWechat: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      required: true
    },
    usedLimitCb: {
      type: Function,
      default: null
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    },
    defaultErrMsg() {
      return '合同异常，请稍候再试。';
    },
    isEmptyFile() {
      return this.errMsg === '该文档并非完整、有效商业合同，请重新上传后审查';
    }
  },
  mounted() {
    this.initCheckDetail();
  },
  methods: {
    async initCheckDetail(classId = '') {
      try {
        this.modalLoading = true;
        const params = { id: this.detail.id };
        if (classId) {
          params.classId = classId;
        }
        const { data } = await services.contract.getContractCheckInfo(params);

        if (!classId) {
          await this.fetchClassList({ type: data.type }, { classId: data.classId, className: data.className });
        }

        if (data.status === 'failed') {
          this.errMsg = data.message || this.defaultErrMsg;
        } else if (!data.roleOption) {
          this.errMsg = this.defaultErrMsg;
        } else {
          const roleOptions = [];
          ['partA', 'partB'].forEach(roleKey => {
            const roleVal = data.roleOption[roleKey];
            if (roleVal) {
              roleOptions.push(roleVal);
            }
          });
          this.classId = data.classId;
          this.type = data.type;
          this.curCheckRole = data.role;
          this.role = this.curCheckRole || roleOptions[0];
          this.roleOptions = roleOptions;
          if (this.role) {
            this.errMsg = '';
          } else {
            this.errMsg = this.defaultErrMsg;
          }
        }
      } catch (err) {
        this.errMsg = err.message || this.defaultErrMsg;
        this.$error(err);
      } finally {
        this.modalLoading = false;
      }
    },
    async confirmHandle() {
      try {
        this.confirmLoading = true;
        if (this.curCheckRole) {
          const isChange = this.role !== this.curCheckRole;
          if (isChange) {
            await services.dataCleaner.checkedContract(this.detail.id, { role: this.role, classId: this.classId });
          }
        } else {
          await services.dataCleaner.checkedContract(this.detail.id, { role: this.role, classId: this.classId });
        }
        this.$emit('success', this.role);
        this.visible = false;
      } catch (err) {
        if (err.code === usedLimitErrCode) {
          if (err.data) {
            if (this.usedLimitCb) {
              this.usedLimitCb(err.data);
            } else {
              this.$store.dispatch('initOrderModal', err.data.product);
              this.$store.dispatch('initOrderCb', () => this.confirmHandle());
            }
          } else {
            this.$store.dispatch('initOrderCb', () => this.confirmHandle());
          }
        }
        if (err.code === categoryLimitErrCode) {
          this.categoryTipModal = {
            show: true,
            productInfo: err.data
          };
        }
        this.$error(err);
      } finally {
        this.confirmLoading = false;
      }
    },
    async fetchClassList({ type, keyword }, initOptions) {
      try {
        this.classLoading = true;
        const params = {};
        if (keyword) {
          params.keyword = keyword;
        } else {
          if (type) {
            params.type = type;
          }
        }
        const result = await services.contract.getContractCategory(params);
        if (initOptions && initOptions.classId) {
          const idx = result.data.findIndex(o => o._id === initOptions.classId);
          if (idx === -1) {
            result.data.unshift({
              _id: initOptions.classId,
              _source: { realName: initOptions.className || initOptions.classId }
            });
          }
        }
        this.curSearchKeyword = keyword || '';
        if (!this.curSearchKeyword) {
          result.data.push({ _id: 'disabled-item', _source: { realName: '更多类型合同请进行检索' } });
        }
        this.classList = result.data;
      } catch (err) {
        this.$error(err);
      } finally {
        this.classLoading = false;
      }
    },
    formatClassName(name, keyword) {
      if (!keyword || !name) {
        return name || '-';
      }
      try {
        const reg = new RegExp(keyword, 'g');
        name = name.replace(reg, word => `<span class="highlight-text">${word}</span>`);
      } catch (err) {
        // todo
      }
      return name;
    }
  }
};
</script>

<style lang="scss">
.pick-position-select {
  .el-select-dropdown__item {
    &.is-disabled {
      color: #9599a5;
      border-top: 1px solid #e8ebef;
      margin-top: 4px;
      text-align: center;
    }
    .highlight-text {
      color: #e42626;
    }
  }
}
</style>
<style lang="scss" scoped>
.pick-position-modal {
  .position-radio-text {
    display: inline-block;
    max-width: 100px;
    vertical-align: top;
  }
  .pick-position-help-tip {
    line-height: 20px;
    margin-bottom: 10px;
    padding-left: 14px;
  }
}
</style>
